import type { IconName, TagColor } from '@billy/design-system'
import { Tag } from '@billy/design-system'
import { ReactElement } from 'react'

interface EInvoiceStatusTagProps {
  color: TagColor
  icon?: IconName
  label: string
}

export const EInvoiceStatusTag = ({ color, icon, label }: EInvoiceStatusTagProps): ReactElement => (
  <Tag color={color} icon={icon} size="sm" type="subtle">
    {label}
  </Tag>
)
